// In-memory cache for the lists shown on the "Start a conversation"
// page (Gmail inbox and Google Chat spaces). The setup form is unmounted every
// time a conversation is opened, so without this every return to the page
// re-fetched the lists from Google. Entries live until the user refreshes
// (or the JS bundle is reloaded) and are scoped to the signed-in user so a
// different account never sees another's lists.

const entries = new Map();

export function setupListCacheKey(scope, kind, query = "") {
  return JSON.stringify([scope ?? "", kind, (query ?? "").trim()]);
}

// Returns the cached entry, or null when missing.
export function readSetupListCache(key) {
  return entries.get(key) ?? null;
}

// Stores a freshly loaded first page. `loadedAt` marks when the list was
// fetched so the UI can show "last updated" and later appends keep that time.
export function writeSetupListCache(key, data, now = Date.now()) {
  const entry = { ...data, loadedAt: now };
  entries.set(key, entry);
  return entry;
}

// Merges an infinite-scroll page into an existing entry so the restored list
// contains everything the user had already scrolled through.
export function appendSetupListCache(key, data) {
  const entry = readSetupListCache(key);
  if (!entry) return null;

  const updated = { ...entry, ...data, loadedAt: entry.loadedAt };
  entries.set(key, updated);
  return updated;
}

export function clearSetupListCache() {
  entries.clear();
}
